var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudTopLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 72,
    viewBox: "0 0 220 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M213.086 50.0699C204.993 46.2655 194.665 48.0167 188.262 54.2366C189.048 49.5264 186.088 44.8162 182.041 42.3403C177.995 39.804 173.163 39.0793 168.391 38.7774C161.687 38.3547 153.352 39.7436 151.298 46.1447C149.668 37.4489 142.601 30.0816 134.024 27.9681C125.448 25.8545 115.784 29.1154 110.288 35.9996C110.65 28.0888 107.087 20.2988 101.59 14.562C96.0941 8.82519 88.8463 5.08114 81.2361 2.72603C69.7 -0.836838 56.8351 -1.19914 45.6613 3.39031C34.4876 7.97977 25.2466 18.0041 23.1327 29.9004C22.1059 35.5769 22.8307 41.7364 26.213 46.3863C21.4415 43.0046 14.7977 42.4007 9.48258 44.8766C4.2279 47.4129 0.42279 52.9081 0 58.7657L1.63076 65.9518C3.20112 69.2731 7.61022 69.877 11.2341 69.9978C65.7136 72.051 120.193 72.1113 174.673 70.1789C185.544 69.8166 196.416 69.3335 207.167 67.5219C210.006 67.0388 212.905 66.4349 215.321 64.9252C217.737 63.4155 219.67 60.7585 219.549 57.8599C219.428 54.297 216.348 51.5796 213.086 50.0699Z",
    fill: "#3E809D",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudTopLeft);
export default __webpack_public_path__ + "static/media/cloud-top-left.b198ce06b2a79fb9b049f3678c9e4d36.svg";
export { ForwardRef as ReactComponent };